import React, { Fragment, useEffect, useState, useRef, useContext } from "react";
import { getCuYears, getCuByYear, downloadReportCu, downloadReportCuV2, confirmEmpDoc, deleteEmpDoc, deleteCu } from "../services/api";

import { ReassignDialog } from "./confirm";
import { MessageContext } from "../contexts/message";
import { confirmAllEmpDocs, deleteAllEmpDocs } from "../services/api";
import { estraiMessaggiErrore } from "../services/utils";

import { Link } from "wouter";
import moment from "moment";
import Swal from "sweetalert2";

import Fetching from "./fetching";
import LoadingState from "./fetchingV2";
import FilePreviewModal from "./preview_modal";
import CustomTooltipComponent from "./custom_tooltip_component";

import { CheckCircleIcon, XCircleIcon, CheckIcon, TrashIcon, PaperClipIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import PrettyPagination from "./pretty_pagination";

import { useLocation } from "wouter";

const SearchField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F9FAFB",
    borderRadius: 12,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E5E7EB",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#C7D2FE",
  },
  // elimina il bordo “quadrato” solo sul focus
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
    borderWidth: 0,
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    boxShadow: "none",
    outline: "none",
  },
}));

function isAbortError(err) {
  if (!err) return false;
  if (err.name === "AbortError") return true;
  if (err?.cause?.name === "AbortError") return true;
  if (err.name === "CanceledError") return true;
  if (err.code === "ERR_CANCELED") return true;
  if (
    typeof err.message === "string" &&
    err.message.toLowerCase().includes("canceled")
  ) {
    return true;
  }
  if (err.aborted === true) return true;
  return false;
}


function YearPlaceholderMessage() {
  return (
    <div className="shadow-md bg-indigo-200/40 text-indigo-800 mt-2 flex justify-center items-center text-base font-semibold text-gray-900 py-6 rounded-lg min-h-[3rem] border border-indigo-200">
      Seleziona l&apos;anno per visualizzare le CU
    </div>
  );
}


// -------------------------------------------
// ROW SINGOLA CU (uguale alla tua CuRow)
// -------------------------------------------
function CuRow({
  cu,
  isOpen,
  onToggle,
  onReassign,
  onConfirm,
  onDelete,
  setPreviewDoc,
}) {
  return (
    <>
      <li
        className={`flex items-center cursor-pointer justify-between gap-x-6 px-5 py-2 ${
          cu.is_confirmed ? "" : "bg-red-50"
        }`}
        onClick={onToggle}
      >
        <div className="min-w-0">
          <div className="flex items-start gap-x-3">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onToggle();
              }}
            >
              {isOpen ? (
                <KeyboardArrowUpIcon className="w-5 h-5" />
              ) : (
                <KeyboardArrowDownIcon className="w-5 h-5" />
              )}
            </button>

            <CustomTooltipComponent title="Vai all'anagrafica">
              <>
                <Link
                  to={`/dipendenti/${cu.employee_cf}`}
                  onClick={(e) => e.stopPropagation()}
                  className="inline-flex flex-col text-left hover:text-indigo-600 hover:underline"
                >
                  <span className="font-medium text-sm text-gray-900">
                    {cu.employee_last_name || cu.employee_first_name
                      ? `${cu.employee_last_name || ""} ${
                          cu.employee_first_name || ""
                        }`.trim()
                      : (cu.employee_cf)}
                  </span>

                  {(cu.employee_last_name ||
                    cu.employee_first_name) && (
                    <span className="text-xs text-gray-500">
                      {cu.employee_cf}
                    </span>
                  )}
                </Link>
              </>
            </CustomTooltipComponent>
          </div>

          <ul className="mt-1 flex flex-wrap gap-x-4 text-xs text-gray-500 pl-8">
            <li className="flex items-center gap-x-1">
              Confermata:
              {cu.is_confirmed ? (
                <CheckCircleIcon className="h-4 w-4 text-green-500" />
              ) : (
                <XCircleIcon className="h-4 w-4 text-red-500" />
              )}
            </li>

            <li className="flex items-center gap-x-1">
              Letta:
              {cu.read_at ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  {moment(cu.read_at).format("DD/MM/YYYY HH:mm")}
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-500">Non letta</span>
                </>
              )}
            </li>
          </ul>
        </div>

        <div className="flex items-center gap-1 shrink-0">
          {!cu.is_confirmed && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onReassign();
                }}
                className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                Riassegna
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onConfirm();
                }}
                className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 me-2"
              >
                Conferma
              </button>
            </>
          )}

          <CustomTooltipComponent title="Apri anteprima">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setPreviewDoc({
                  url: cu.download_link,
                  name: `CU ${cu.year}`,
                });
              }}
              className="inline-flex items-center pe-3 text-indigo-600 hover:underline"
            >
              <MagnifyingGlassIcon className="h-5 w-5" />
            </button>
          </CustomTooltipComponent>

          <CustomTooltipComponent title="Elimina">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              className="action-btn text-gray-700 hover:text-red-600"
            >
              <TrashIcon className="h-5 w-5" />
            </button>
          </CustomTooltipComponent>
        </div>
      </li>

      {isOpen && (
        <div className="bg-gray-50 px-6 py-4 text-sm shadow-lg border border-gray-300 mx-6 mb-4 mt-4">
          <dl className="grid grid-cols-12 gap-x-4 gap-y-1 items-center">
            <dt className="col-span-2 font-semibold">File</dt>
            <dd className="col-span-10">
              <button
                type="button"
                onClick={() =>
                  setPreviewDoc({
                    url: cu.download_link,
                    name: `CU ${cu.year}`,
                  })
                }
                className="inline-flex items-center gap-1 text-indigo-600 hover:underline"
              >
                <MagnifyingGlassIcon className="h-4 w-4" />
                <span>Apri anteprima</span>
              </button>
            </dd>

            <dt className="col-span-2 font-semibold">Caricato</dt>
            <dd className="col-span-10">
              {moment(cu?.created_at).format("DD/MM/YYYY HH:mm")}
            </dd>

            <dt className="col-span-2 font-semibold">Anno</dt>
            <dd className="col-span-10">{cu.year}</dd>

            <dt className="col-span-2 font-semibold">Status</dt>
            <dd className="col-span-10 inline-flex items-center gap-2">
              {cu.is_confirmed ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  <span className="text-green-600">Confermata</span>
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-600">Non confermata</span>
                </>
              )}
            </dd>

            <dt className="col-span-2 font-semibold">Letto</dt>
            <dd className="col-span-10 inline-flex items-center gap-2">
              {cu.read_at ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  {moment(cu.read_at).format("DD/MM/YYYY HH:mm")}
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-500">Non letta</span>
                </>
              )}
            </dd>
          </dl>
        </div>
      )}
    </>
  );
}

// -------------------------------------------
// LISTA CU DELL'ANNO
// -------------------------------------------
function CuList({
  activeYear,
  yearList,
  openCuId,
  toggleRow,
  setSelectedDoc,
  handleConfirmDoc,
  handleDeleteDoc,
  handleDeleteConfirmedDoc,
  setPreviewDoc,
  fetchingReport,
  downloadReport,
  anyToConfirm,
  handleConfirmAllDocs,
  handleDeleteAllDocs,
  loadingYearData,
  search,
  setSearch,
  filteredCount,
  globalTotal,
  confirmedCount,
  toConfirmCount,
  page,
  totalPages,
  onPageChange,
}) {

  const total = Number(filteredCount ?? 0);
  const confirmed = Number(confirmedCount ?? 0);
  const toConfirm = Number(toConfirmCount ?? 0);
  const showOnlyTotal = globalTotal === confirmed;

  return (
    <>
      <div className="shadow-md bg-indigo-200 text-indigo-800 mt-2 flex justify-center text-xl font-semibold text-gray-900 py-6 rounded-lg">
        {activeYear ? `Certificazioni Uniche ${activeYear}` : ""}
      </div>

      {/* Search + pills */}
      <div className="mt-3">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-3">
          <TextField
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              onPageChange?.(1);
            }}
            placeholder="Cerca per cognome, nome o CF"
            size="small"
            fullWidth
            variant="outlined"
            sx={{
              minWidth: 320,

              "& .MuiInputLabel-root": { color: "#6b7280" },
              "&:hover .MuiInputLabel-root": { color: "#4338ca" },
              "& .MuiInputBase-input-MuiOutlinedInput-input": { color: "#4338ca" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#4338ca" },

              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: "#f9fafb",
                height: 40,
              },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c7d2fe", borderWidth: "1px" },
              "& .MuiOutlinedInput-root:hover fieldset": { borderColor: "#818cf8", borderWidth: "1px" },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e5e7eb",
                borderWidth: "1px",
              },

              "& .MuiOutlinedInput-input, & .MuiOutlinedInput-input:focus, & .MuiOutlinedInput-input:focus-visible": {
                outline: "none",
                boxShadow: "none",
              },
              "& .MuiOutlinedInput-root:focus-within": {
                outline: "none",
                boxShadow: "none",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          

          <div className="mt-3 flex flex-wrap gap-2 uppercase">
            {globalTotal > 0 && (
              <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1 text-xs font-semibold">
                <span className="w-2 h-2 rounded-full bg-indigo-500" />
                caricate: <span className="font-bold">{globalTotal}</span>
              </div>
            )}

            {!showOnlyTotal && (
              <>
                <div className="inline-flex items-center gap-2 rounded-full bg-red-50 text-red-700 border border-red-100 px-3 py-1 text-xs font-semibold">
                  <span className="w-2 h-2 rounded-full bg-red-500" />
                  da confermare: <span className="font-bold">{toConfirm}</span>
                </div>

                <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1 text-xs font-semibold">
                  <span className="w-2 h-2 rounded-full bg-emerald-500" />
                  confermate: <span className="font-bold">{confirmed}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-2">
        <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
          {loadingYearData ? (
            <div className="p-2 flex justify-center w-full">
              <LoadingState
                spinnerSize={30}
                label="Caricamento..."
                center={true}
                fullWidth={true}
                minHeight="auto"
                className="inline-block align-middle border border-dashed rounded-md border-gray-300 py-2 italic"
              />
            </div>
          ) : (
            <>
              <ul role="list" className="divide-y divide-gray-100">
                {yearList.map((cu) => (
                  <CuRow
                    key={cu.id}
                    cu={cu}
                    isOpen={openCuId === cu.id}
                    onToggle={() => toggleRow(cu.id)}
                    onReassign={() =>
                      setSelectedDoc({
                        id: cu.id,
                        type: "certification_of_incomes",
                        employee: {
                          cf: cu.employee_cf,
                          first_name: cu.employee_first_name,
                          last_name: cu.employee_last_name,
                          name:
                            `${cu.employee_last_name || ""} ${
                              cu.employee_first_name || ""
                            }`.trim() || cu.employee_cf,
                        },
                      })
                    }
                    onConfirm={() =>
                      handleConfirmDoc({
                        id: cu.id,
                        type: "certification_of_incomes",
                      })
                    }
                    onDelete={() =>
                      cu.is_confirmed
                        ? handleDeleteConfirmedDoc(cu.id)
                        : handleDeleteDoc({
                            id: cu.id,
                            type: "certification_of_incomes",
                          })
                    }
                    setPreviewDoc={setPreviewDoc}
                  />
                ))}
              </ul>

              {/* Pagination (desktop) */}
              {activeYear && totalPages > 1 ? (
                <div className="flex justify-center">
                  <PrettyPagination
                    page={page}
                    totalPages={totalPages}
                    totalCount={filteredCount}
                    onChange={(value) => onPageChange?.(value)}
                    labelSingolare="certificazione"
                    labelPlurale="certificazioni"
                    className="mt-3 py-3 border border-t border-gray-200 bg-gray-50"
                  />
                </div>
              ) : null}
             </> 
          )}
        </div>
      </div>

      <div className="text-center mt-10 flex flex-wrap justify-around">
        {activeYear && (
          <>
            {fetchingReport ? (
              <button
                disabled
                type="button"
                className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-200 px-3 py-2 text-sm font-semibold text-white shadow-sm"
              >
                <svg
                  className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </button>
            ) : (
              <div className="grid sm:grid-flow-col gap-3 md:grid-flow-col lg:grid-flow-col xl:grid-flow-col">
                <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                  <button
                    onClick={downloadReport}
                    type="button"
                    className="grow inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 m-3 justify-center"
                  >
                    Stampa Report {activeYear}
                    <PaperClipIcon className="-mr-0.5 h-5 w-5" />
                  </button>
                </div>

                {anyToConfirm && (
                  <>
                    <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                      <button
                        onClick={handleConfirmAllDocs}
                        type="button"
                        className="grow inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 m-3 justify-center"
                      >
                        Conferma tutte {activeYear}
                        <CheckIcon className="-mr-0.5 h-5 w-5" />
                      </button>
                    </div>

                    <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                      <button
                        onClick={handleDeleteAllDocs}
                        type="button"
                        className="grow inline-flex items-center gap-x-1.5 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 m-3 justify-center"
                      >
                        Cancella tutte {activeYear}
                        <TrashIcon className="-mr-0.5 h-5 w-5" />
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

// -------------------------------------------
// COMPONENTE PRINCIPALE: CuTable V2-style
// -------------------------------------------
export default function CuTable({ token }) {
  const message = useContext(MessageContext);

  // lista anni [{year, count}]
  const [years, setYears] = useState([]);

  // anno selezionato
  const [activeYear, setActiveYear] = useState(null);

  // cache dati per anno:
  // {
  //   2024: { loading: false, list: [...] },
  //   2023: { loading: true, list: [] },
  // }
  const [yearData, setYearData] = useState({});

  // UI state
  const [openCuId, setOpenCuId] = useState(null);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [fetchingYears, setFetchingYears] = useState(false);
  const [fetchingReport, setFetchingReport] = useState(false);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);

  const [filteredCount, setFilteredCount] = useState(0);
  const [globalTotal, setGlobalTotal] = useState(0); 
  const [confirmedCount, setConfirmedCount] = useState(0);
  const [toConfirmCount, setToConfirmCount] = useState(0);

  const [location, setLocation] = useLocation();
  
  const totalPages = Math.max(1, Math.ceil((Number(filteredCount) || 0) / pageSize));

  const pendingNavRef = useRef({ year: null, applied: false });

  // controllers per abort
  const yearControllerRef = useRef(null);
  const yearReqIdRef = useRef(0);

  // --- refs per fix paginazione post-delete ---
  const pageRef = useRef(page);
  const listLenRef = useRef(0);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    listLenRef.current = (yearData[activeYear]?.list || []).length;
  }, [activeYear, yearData]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 350);
    return () => clearTimeout(t);
  }, [search]);

  useEffect(() => {
    if (!location) return;

    if (!window.location.search) return;

    const params = new URLSearchParams(window.location.search);
    const year = Number(params.get("year"));

    if (!year) return;

    pendingNavRef.current = { year, applied: false };

    setActiveYear(year);
    setPage(1);
    setSearch("");
    setOpenCuId(null);

    setLocation("/cu", { replace: true });
  }, [location, setLocation]);

  // quando cambia anno/pagina/ricerca => ricarica lista
  useEffect(() => {
    if (!activeYear) return;
    ensureYearLoaded(activeYear, page, debouncedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeYear, page, debouncedSearch, pageSize]);

  useEffect(() => {
    setPage(1);
  }, [activeYear, debouncedSearch]);

  // helper
  const toggleRow = (id) =>
    setOpenCuId((prev) => (prev === id ? null : id));

  const anyToConfirm =
    (yearData[activeYear]?.list || []).some((c) => !c.is_confirmed) ||
    false;

  function abortYearRequest() {
    if (yearControllerRef.current) {
      yearControllerRef.current.abort();
      yearControllerRef.current = null;
    }
  }

  // 1. carico SOLO la lista anni all'inizio
  useEffect(() => {
    if (!token) return;
    if (years.length > 0) return;

    (async () => {
      setFetchingYears(true);
      try {
        const controller = new AbortController();
        const data = await getCuYears(
          token,
          controller.signal,
          "certification_of_incomes",
          null // se vuoi filtrare per employee singolo, passa id qui
        );

        // ordina anni desc tipo payroll
        const ordered = Array.isArray(data)
          ? [...data].sort((a, b) => b.year - a.year)
          : [];

        setYears(ordered);

        // NON apriamo subito il primo anno per evitare il "vuoto" iniziale
        // lasciamo activeYear null finché l'utente non clicca
      } catch (err) {
        if (!isAbortError(err)) {
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: "Errore nel caricamento anni CU",
          });
        }
      } finally {
        setFetchingYears(false);
      }
    })();
  }, [token, years.length]);

  // 2. quando l'utente seleziona un anno, carichiamo i dettagli se non già in cache
  async function ensureYearLoaded(year, pageArg = 1, searchArg = "") {
    abortYearRequest();

    setYearData((prev) => ({
      ...prev,
      [year]: { loading: true, list: prev[year]?.list || [] },
    }));

    const controller = new AbortController();
    yearControllerRef.current = controller;
    const reqId = ++yearReqIdRef.current;

    try {
      const resp = await getCuByYear(
        token,
        year,
        controller.signal,
        "certification_of_incomes",
        null,
        {
          page: pageArg,
          page_size: pageSize,
          search: searchArg || undefined,
        }
      );

      if (reqId !== yearReqIdRef.current) return;

      const list = Array.isArray(resp) ? resp : (resp?.results || []);

      setYearData((prev) => ({
        ...prev,
        [year]: { loading: false, list },
      }));

      const nextCount = Number(resp?.count ?? 0);
      setFilteredCount(nextCount);
      setGlobalTotal(Number(resp?.global_total ?? 0));
      setConfirmedCount(Number(resp?.confirmed_count ?? 0));
      setToConfirmCount(Number(resp?.to_confirm_count ?? 0));
      
      return resp;
    } catch (err) {
      if (reqId !== yearReqIdRef.current) return;

      if (isAbortError(err)) return;

      // DRF: { detail: "Invalid page." }
      const detail = err?.response?.data?.detail;
      const isInvalidPage =
        typeof detail === "string" && detail.toLowerCase().includes("invalid page");

      if (isInvalidPage) {
        const fallbackPage = Math.max(1, pageArg - 1);
        if (fallbackPage !== pageArg) {
          return await ensureYearLoaded(year, fallbackPage, searchArg);
        }
      }

      Swal.fire({
        icon: "error",
        title: "Errore",
        text: `Errore nel caricamento CU ${year}`,
      });

      setYearData((prev) => ({
        ...prev,
        [year]: { loading: false, list: prev[year]?.list || [] },
      }));
    } finally {
      if (yearControllerRef.current === controller) yearControllerRef.current = null;
    }
  }

  async function refetchActiveYear(opts = {}) {
    if (!activeYear) return;

    const requestedPage = opts.page ?? page;
    return await ensureYearLoaded(activeYear, requestedPage, debouncedSearch);
  }

  async function refreshAfterDelete({ removedCount = 1 } = {}) {
    if (!activeYear) return;

    const currentPage = pageRef.current;
    const currentLen = listLenRef.current;

    const willBeEmpty = currentLen - removedCount <= 0;
    const targetPage = willBeEmpty ? Math.max(1, currentPage - 1) : currentPage;

    // aggiorno subito la UI
    if (targetPage !== page) setPage(targetPage);

    // ricarico forzando la pagina target (senza aspettare l’effect)
    await refetchActiveYear({ page: targetPage });
  }

  const yearsControllerRef = useRef(null);
    const yearsReqIdRef = useRef(0);

    function abortYearsRequest() {
      if (yearsControllerRef.current) {
        yearsControllerRef.current.abort();
        yearsControllerRef.current = null;
      }
    }

    async function refetchYears() {
      if (!token) return;

      abortYearsRequest();
      const controller = new AbortController();
      yearsControllerRef.current = controller;
      const reqId = ++yearsReqIdRef.current;

      try {
        const data = await getCuYears(
          token,
          controller.signal,
          "certification_of_incomes",
          null
        );

        if (reqId !== yearsReqIdRef.current) return;

        const ordered = Array.isArray(data)
          ? [...data].sort((a, b) => b.year - a.year)
          : [];

        setYears(ordered);

        // se l'anno attivo non esiste più (count=0 e l'API lo rimuove) fai fallback
        if (activeYear && !ordered.some((x) => x.year === activeYear)) {
          setActiveYear(ordered[0]?.year ?? null);
          setPage(1);
          setSearch("");
          setOpenCuId(null);
        }
      } finally {
        if (yearsControllerRef.current === controller) {
          yearsControllerRef.current = null;
        }
      }
    }

  // Conferma tutte le CU non confermate dell'anno
  const handleConfirmAllDocs = async () => {
    try {
      if (!activeYear) return;

      const year = activeYear;
      const reference_year = activeYear - 1;
      
      const res = await Swal.fire({
        title: "Conferma CU",
        text: `Vuoi confermare tutte le CU dell'anno ${year}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sì, conferma",
        cancelButtonText: "Annulla",
        cancelButtonColor: "#6b7280",
      });

      if (!res.isConfirmed) return;

      await confirmAllEmpDocs(
        token,
        { year, reference_year },
        "certification_of_incomes"
      );

      await Swal.fire({
        title: "Operazione completata",
        text: "Confermate con successo",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#4f46e5",
      });

      setPage(1);
      await refetchActiveYear({ page: 1 });
      await refetchYears();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: estraiMessaggiErrore(err) || "Errore, riprova più tardi.",
        confirmButtonText: "OK",
      });
    }
  };

  // Cancella tutte le CU non confermate dell'anno
  const handleDeleteAllDocs = async () => {
    try {
      if (!activeYear) return;

      const year = activeYear;
      const reference_year = activeYear - 1; // modifica se diverso
   

      const res = await Swal.fire({
        title: "Elimina CU",
        text: `Vuoi eliminare tutte le CU NON confermate dell'anno ${year}? L’operazione non è reversibile.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sì, elimina",
        cancelButtonText: "Annulla",
        confirmButtonColor: "#dc2626",
        cancelButtonColor: "#6b7280",
        reverseButtons: true,
      });

      if (!res.isConfirmed) return;

      await deleteAllEmpDocs(
        token,
        { year, reference_year },
        "certification_of_incomes"
      );

      await Swal.fire({
        title: "Operazione completata",
        text: "Cancellate con successo",
        icon: "success",
        confirmButtonText: "OK",
      });

      setPage(1);
      await refetchActiveYear({ page: 1 });
      await refetchYears();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: estraiMessaggiErrore(err) || "Errore, riprova più tardi.",
        confirmButtonText: "OK",
      });
    }
  };

  // Conferma singolo documento
  const handleConfirmDoc = async (doc) => {
    const { isConfirmed } = await Swal.fire({
      title: "Confermi questo documento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sì, conferma",
      cancelButtonText: "Annulla",
    });
    if (!isConfirmed) return;

    try {
      await confirmEmpDoc(token, doc.id, doc.type);

      Swal.fire({
        icon: "success",
        title: "Documento confermato",
        timer: 1500,
        showConfirmButton: false,
      });

      await refetchActiveYear();
      await refetchYears();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text:
          err?.response?.data?.detail ||
          "Errore, riprova più tardi",
      });
    }
  };

  // Elimina singolo documento NON confermato
  const handleDeleteDoc = async (doc) => {
    const { isConfirmed } = await Swal.fire({
      title:
        "Sei sicuro di voler cancellare questo file?",
      text: "Una volta cancellato non sarai in grado di recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sì, elimina",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#a3a3a3",
    });
    if (!isConfirmed) return;

    try {
      await deleteEmpDoc(token, doc.id, doc.type);

      Swal.fire({
        icon: "success",
        title: "File cancellato con successo",
        timer: 1500,
        showConfirmButton: false,
      });

      await refreshAfterDelete({ removedCount: 1 });
      await refetchYears()
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: err?.message || "Errore, riprova più tardi",
      });
    }
  };

  // Elimina singolo documento GIÀ confermato (usa deleteCu)
  const handleDeleteConfirmedDoc = async (cuId) => {
    const { isConfirmed } = await Swal.fire({
      title:
        "Sei sicuro di voler cancellare questo file confermato?",
      text: "Una volta cancellato non sarai in grado di recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sì, elimina",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#a3a3a3",
    });
    if (!isConfirmed) return;

    try {
      await deleteCu(token, cuId);

      Swal.fire({
        icon: "success",
        title: "File cancellato con successo",
        timer: 1500,
        showConfirmButton: false,
      });

      await refreshAfterDelete({ removedCount: 1 });
      await refetchYears();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: err?.message || "Errore, riprova più tardi",
      });
    }
  };

  // download report anno
  const downloadReport = async () => {
    if (!activeYear) return;
    setFetchingReport(true);

    try {
      const result = await Swal.fire({
        title: "Scegli il tipo di stampa",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Stampa senza data di conferma",
        denyButtonText: `Stampa con data di conferma`,
        denyButtonColor: "#7066e0",
      });

      let blob = null;
      if (result.isConfirmed) {
        blob = await downloadReportCu(token, activeYear);
      } else if (result.isDenied) {
        blob = await downloadReportCuV2(token, activeYear);
      }

      if (blob instanceof Blob) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `report-${activeYear}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: "Errore durante il download del report. Riprova.",
      });
    } finally {
        setFetchingReport(false);
    }
  };

  if (!fetchingYears && years.length === 0) {
    return (
      <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center">
        <div role="status">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
            />
          </svg>
        </div>
        <span className="mt-2 block text-sm font-semibold text-gray-900">
          Non risultano presenti CU
        </span>
      </div>
    );
  }

  // RENDER COLONNA SINISTRA (anni)
  const renderSidebar = () => {
    if (fetchingYears) {
      return <Fetching />;
    }

    return (
      <>
        {years.map((y) => {
          const isActive = activeYear === y.year;

          return (
            <Fragment key={y.year}>
              {/* CARD ANNO */}
              <div
                className={`flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 ${
                  isActive
                    ? "bg-indigo-200 text-indigo-800"
                    : "bg-white text-gray-900"
                }`}
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  if (activeYear === y.year) return;

                  setActiveYear(y.year);
                  setPage(1);
                  setSearch("");  
                  setOpenCuId(null);
                }}
              >
                <div className="flex flex-1 flex-col justify-between p-6">
                  <div className="flex-1">
                    <p className="text-xl font-semibold">{y.year}</p>
                    <p className="text-sm opacity-70">
                      {y.count} certificazion
                      {y.count === 1 ? "e" : "i"}
                    </p>
                  </div>
                </div>
              </div>

              {/* MOBILE: lista CU dell'anno attivo subito sotto */}
              {isActive && (
                <div className="px-4 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6 xl:hidden">
                  <CuList
                    activeYear={activeYear}
                    yearList={yearData[activeYear]?.list || []}
                    openCuId={openCuId}
                    toggleRow={toggleRow}
                    setSelectedDoc={setSelectedDoc}
                    handleConfirmDoc={handleConfirmDoc}
                    handleDeleteDoc={handleDeleteDoc}
                    handleDeleteConfirmedDoc={handleDeleteConfirmedDoc}
                    setPreviewDoc={setPreviewDoc}
                    fetchingReport={fetchingReport}
                    downloadReport={downloadReport}
                    anyToConfirm={anyToConfirm}
                    handleConfirmAllDocs={handleConfirmAllDocs}
                    handleDeleteAllDocs={handleDeleteAllDocs}
                    loadingYearData={yearData[activeYear]?.loading}
                    search={search}
                    setSearch={setSearch}
                    filteredCount={filteredCount}
                    globalTotal={globalTotal}
                    confirmedCount={confirmedCount}
                    toConfirmCount={toConfirmCount}
                    page={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  // RENDER PANNELLO DESTRO DESKTOP
  const renderRightPanelDesktop = () => {
    const hasActiveYear = !!activeYear;

    return (
      <div className="hidden px-4 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6 xl:block">
        {hasActiveYear ? (
          <CuList
            activeYear={activeYear}
            yearList={yearData[activeYear]?.list || []}
            openCuId={openCuId}
            toggleRow={toggleRow}
            setSelectedDoc={setSelectedDoc}
            handleConfirmDoc={handleConfirmDoc}
            handleDeleteDoc={handleDeleteDoc}
            handleDeleteConfirmedDoc={handleDeleteConfirmedDoc}
            setPreviewDoc={setPreviewDoc}
            fetchingReport={fetchingReport}
            downloadReport={downloadReport}
            anyToConfirm={anyToConfirm}
            handleConfirmAllDocs={handleConfirmAllDocs}
            handleDeleteAllDocs={handleDeleteAllDocs}
            loadingYearData={yearData[activeYear]?.loading}
            search={search}
            setSearch={setSearch}
            filteredCount={filteredCount}
            globalTotal={globalTotal}
            confirmedCount={confirmedCount}
            toConfirmCount={toConfirmCount}
            page={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        ) : (
          <YearPlaceholderMessage />
        )}
      </div>
    );
  };

  // RENDER PRINCIPALE
  return (
    <div className="flex min-h-full flex-col">
      <ReassignDialog
        doc={selectedDoc}
        getDocs={async () => {
          // dopo riassegna ricarichiamo l'anno attivo
          await refetchActiveYear();
          await refetchYears();
        }}
      />

      <div className="mx-auto w-full max-w-7xl grow lg:flex xl:px-2 max-h-100 overflow-y-auto">
        <div className="flex-1 xl:flex">
          {/* Sidebar anni + (su mobile) lista CU dell'anno attivo */}
          <div className="border-b px-4 py-6 sm:px-6 lg:pl-2 xl:w-72 xl:shrink-0 xl:border-b-0 xl:pl-6">
            {renderSidebar()}
          </div>

          {/* Pannello destro desktop */}
          {renderRightPanelDesktop()}
        </div>
      </div>

      <FilePreviewModal
        doc={previewDoc}
        onClose={() => setPreviewDoc(null)}
      />
    </div>
  );
}